module.exports = __webpack_public_path__ + "static/pnevmo1-5ccd15b061a0b99b4c20d3629e229aac.webp";